"use strict";

var _taggedTemplateLiteral = require("/opt/buildhome/repo/node_modules/@babel/runtime/helpers/taggedTemplateLiteral.js");
var _templateObject, _templateObject2, _templateObject3;
Object.defineProperty(exports, "__esModule", {
  value: true
});
const codegen_1 = require("ajv/dist/compile/codegen");
const _util_1 = require("./_util");
const error = {
  message: _ref => {
    let {
      params: {
        missingPattern
      }
    } = _ref;
    return (0, codegen_1.str)(_templateObject || (_templateObject = _taggedTemplateLiteral(["should have property matching pattern '", "'"])), missingPattern);
  },
  params: _ref2 => {
    let {
      params: {
        missingPattern
      }
    } = _ref2;
    return (0, codegen_1._)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["{missingPattern: ", "}"])), missingPattern);
  }
};
function getDef() {
  return {
    keyword: "patternRequired",
    type: "object",
    schemaType: "array",
    error,
    code(cxt) {
      const {
        gen,
        schema,
        data
      } = cxt;
      if (schema.length === 0) return;
      const valid = gen.let("valid", true);
      for (const pat of schema) validateProperties(pat);
      function validateProperties(pattern) {
        const matched = gen.let("matched", false);
        gen.forIn("key", data, key => {
          gen.assign(matched, (0, codegen_1._)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["", ".test(", ")"])), (0, _util_1.usePattern)(cxt, pattern), key));
          gen.if(matched, () => gen.break());
        });
        cxt.setParams({
          missingPattern: pattern
        });
        gen.assign(valid, (0, codegen_1.and)(valid, matched));
        cxt.pass(valid);
      }
    },
    metaSchema: {
      type: "array",
      items: {
        type: "string",
        format: "regex"
      },
      uniqueItems: true
    }
  };
}
exports.default = getDef;
module.exports = getDef;